module.exports = __webpack_public_path__ + "img/644.0dd4b44d.jpg";